/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect, useState, useCallback } from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { getSubAccounts } from 'actions/user';
import Render from 'components/render';
import { IS_INDIAN_EXCHANGE, MARGIN_TYPES } from 'constants/constants';
import { noop } from 'helpers/utils';
import { userSelector } from 'selectors/otherSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import {
  LeftArrowIcon,
  MobileModalCloseIconNew,
  RightGreyArrow,
  TickRoundFilled,
} from 'styles/assets/icons';
import DeltaButton from 'UIKit/DeltaButton';

import styles from './leverage.module.scss';
import { IsolatedMargin, PortfolioMargin, CrossMargin } from './marginTypes';
import { ChangeAccount } from './marginTypes/helpers';

interface LeverageProps {
  isolatedError?: {
    code: string;
  };
  resetIsolatedError?: () => void;
  isSubAccountCreate?: boolean;
  setMarginMode?: (obj: { margin_mode: string }) => void;
  onSubmit: (obj: { user_id: string | number; margin_mode: string }) => void;
  subAccountUser?: { user_id: string | number };
  isSubAccountModal?: boolean;
  subAccountMarginMode?: string;
  // fetchSubAccounts?: () => void;
  onCancel: () => void;
  marginType: string | undefined;
  showCrossIcon: boolean;
  closeMarginPopupOnBack?: boolean;
  dataTestId?: string;
}

const AccountMarginMode = ({
  subAccountMarginMode,
  showCrossIcon,
  marginType,
  isolatedError,
  resetIsolatedError,
  isSubAccountCreate,
  setMarginMode,
  onSubmit,
  subAccountUser,
  isSubAccountModal,
  // fetchSubAccounts,
  onCancel,
  closeMarginPopupOnBack,
  dataTestId = '',
}: LeverageProps) => {
  const { t } = useTranslation(['trading', 'portfolioMargin', 'common', 'errors']);
  const dispatch = useAppDispatch();

  const [marginTypeValue, setMarginType] = useState(marginType || subAccountMarginMode);
  const [isAccountChangeMode, setIsAccountChangeMode] = useState(false);
  const [shoudlShowCrossIcon, setShowCrossIcon] = useState(showCrossIcon);
  const user = useAppSelector(state => userSelector(state));

  useEffect(() => {
    return () => {
      if (isolatedError?.code) {
        resetIsolatedError?.();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // This has been used only for isolated
  const updateMarginModeFun = (marginMode: string) => {
    if (isSubAccountCreate) {
      setMarginMode?.({
        margin_mode: marginMode,
      });
    } else {
      onSubmit({
        margin_mode: marginMode,
        user_id: (subAccountUser?.user_id || user?.id)!,
      });
    }
  };

  const goBack = () => {
    setIsAccountChangeMode(false);
    setShowCrossIcon(true);
    if (isolatedError?.code) {
      resetIsolatedError?.();
    }
  };

  const fetchSubAccounts = useCallback(() => {
    dispatch(getSubAccounts());
  }, [dispatch]);

  const portfolioMarginSubmit = () => {
    if (!isSubAccountModal) {
      goBack();
    } else {
      fetchSubAccounts();
      onCancel();
    }
  };

  const changeMarginType = marginTypeVal => {
    setMarginType(marginTypeVal);
    if (isolatedError?.code) {
      resetIsolatedError?.();
    }
  };

  const enableAccountChangeMode = () => {
    setIsAccountChangeMode(true);
    setShowCrossIcon(false);
  };

  const mainUser = user.main_account || user;
  const subAccounts = [mainUser, ...user.sub_accounts];

  return (
    (<div
      className={styles[`leverage-modal`]}
      data-testid={dataTestId}
      data-palette="AccountMarginMode">
      <div
        className={cn(
          styles.title,
          'flex-set align-items-center',
          { 'justify-content-between': shoudlShowCrossIcon },
          { 'justify-content-start': !shoudlShowCrossIcon },
          { [styles.subaccount]: isSubAccountModal && shoudlShowCrossIcon },
          { [styles.subaccountCreate]: isSubAccountCreate }
        )}
      >
        {!shoudlShowCrossIcon && (
          <span
            data-testid="goBackLeverage"
            onKeyDown={noop}
            role="button"
            tabIndex={0}
            onClick={closeMarginPopupOnBack ? onCancel : goBack}
            data-palette="AccountMarginMode">
            <LeftArrowIcon className={styles[`back-arrow`]} />
          </span>
        )}
        <span>
          {isAccountChangeMode
            ? t('portfolioMargin:change_account_mode')
            : t('portfolioMargin:change_margin_mode')}
        </span>
        {shoudlShowCrossIcon && (
          <span
            onKeyDown={noop}
            role="button"
            tabIndex={0}
            data-testid="closeIconLeverage"
            onClick={() => onCancel()}
            data-palette="AccountMarginMode">
            <MobileModalCloseIconNew className={styles[`close-icon`]} />
          </span>
        )}
      </div>
      <Render when={isAccountChangeMode}>
        <ChangeAccount onCancel={goBack} handleCloseModal={onCancel} />
      </Render>
      <Render when={!isAccountChangeMode}>
        <>
          <Render when={!isSubAccountModal}>
            <div className={styles.accountInUse}>
              <div className={styles.headTitle}>
                {t('trading:leverageSection.account_in_use')}
                {subAccounts.length > 1 && (
                  <span
                    data-testid="change-account-btn"
                    className={styles.link}
                    role="button"
                    tabIndex={0}
                    onKeyDown={noop}
                    onClick={() => enableAccountChangeMode()}
                    data-palette="AccountMarginMode">
                    {t('trading:leverageSection.change')} <RightGreyArrow />{' '}
                  </span>
                )}
              </div>
              <div className={styles.highlight}> {user.account_name} </div>
            </div>
          </Render>
          <div
            className={cn(styles[`head-tabs`], 'd-flex', {
              [styles['head-tabsIndianExchange']]: IS_INDIAN_EXCHANGE,
            })}
            data-palette="AccountMarginMode">
            <DeltaButton
              data-testid="setMarginTypeIsolated"
              onClick={() => changeMarginType(MARGIN_TYPES.ISOLATED)}
              className={cn(styles.tab, {
                [styles.active]: marginTypeValue === MARGIN_TYPES.ISOLATED,
              })}
              wrapperClassName="d-flex align-items-center"
            >
              {((marginType === MARGIN_TYPES.ISOLATED && !subAccountMarginMode) ||
                subAccountMarginMode === MARGIN_TYPES.ISOLATED) && (
                <div data-palette="AccountMarginMode">
                  <TickRoundFilled />
                </div>
              )}
              <div>{t('portfolioMargin:isolated')}</div>
            </DeltaButton>
            <DeltaButton
              data-testid="setMarginTypePortfolio"
              onClick={() => changeMarginType(MARGIN_TYPES.PORTFOLIO)}
              className={cn(styles.tab, {
                [styles.active]: marginTypeValue === MARGIN_TYPES.PORTFOLIO,
              })}
              wrapperClassName="d-flex align-items-center"
            >
              {((marginType === MARGIN_TYPES.PORTFOLIO && !subAccountMarginMode) ||
                subAccountMarginMode === MARGIN_TYPES.PORTFOLIO) && (
                <div data-palette="AccountMarginMode">
                  <TickRoundFilled />
                </div>
              )}
              <div>{t('portfolioMargin:portfolio')}</div>
            </DeltaButton>
            <DeltaButton
              data-testid="setMarginTypeCross"
              onClick={() => changeMarginType(MARGIN_TYPES.CROSS)}
              className={cn(styles.tab, {
                [styles.active]: marginTypeValue === MARGIN_TYPES.CROSS,
              })}
              wrapperClassName="d-flex align-items-center"
            >
              {((marginType === MARGIN_TYPES.CROSS && !subAccountMarginMode) ||
                subAccountMarginMode === MARGIN_TYPES.CROSS) && (
                <div data-palette="AccountMarginMode">
                  <TickRoundFilled />
                </div>
              )}
              <div className="d-flex align-items-center">
                {t('portfolioMargin:cross')}
              </div>
            </DeltaButton>
          </div>
          <Render when={marginTypeValue === MARGIN_TYPES.ISOLATED}>
            <IsolatedMargin
              data-testid="isolatedComponent"
              margin_mode={marginType}
              subAccountMarginMode={subAccountMarginMode}
              onCancel={onCancel}
              onSubmit={updateMarginModeFun}
              isolatedError={isolatedError}
            />
          </Render>
          <Render when={marginTypeValue === MARGIN_TYPES.PORTFOLIO}>
            <PortfolioMargin
              margin_mode={marginType}
              onCancel={onCancel}
              submit={portfolioMarginSubmit}
              isSubAccountCreate={isSubAccountCreate}
              setMarginMode={setMarginMode}
              subAccountUser={subAccountUser}
              subAccountMarginMode={subAccountMarginMode}
            />
          </Render>
          <Render when={marginTypeValue === MARGIN_TYPES.CROSS}>
            <CrossMargin
              data-testid="crossMarginComponent"
              margin_mode={marginType}
              subAccountMarginMode={subAccountMarginMode}
              onCancel={onCancel}
              onSubmit={updateMarginModeFun}
              isolatedError={isolatedError}
            />
          </Render>
        </>
      </Render>
    </div>)
  );
};

export default AccountMarginMode;
